<!--
 * @Author: zyc
 * @Date: 2020-03-08 23:25:00
 * @Description: 
-->
<template>
  <div class="home">
    <Top-bar />

    <HeaderBar :active="0"></HeaderBar>
    <form class="form-search">
      <input
        type="search"
        class="ipt-search"
        @blur="toSearch"
        v-model="searchKeyword"
      />
      <div class="btn-searchs"></div>
    </form>
    <div class="adsItem" style="display: flex; justify-content: center; align-items: center; width: 100%; overflow: hidden;">
      <div id='div-gpt-ad-1784883062238-0' style='min-width: 300px; min-height: 250px;'></div>
    </div>
    <CustomHeader></CustomHeader>
    <Skeleton v-if="popularList.length == 0"></Skeleton>
    <GamesMore
      :leftIcon="'High Score'"
      :leftText="'High Score'"
      v-if="popularList.length > 0"
    >
      <template #content>
        <div class="main1">
          <a
            class="main1-item"
            v-for="(item, index) in popularList"
            :key="index"
            :href="`detail.html?id=${item.id}`"
          >
            <img v-lazy="item.gamelogo" alt="" />
            <h1 class="name">{{ item.gamename }}</h1>
            <div style="margin-left:0.30rem">
              <StarCount
                :imgUrl="star"
                :starwidth="0.27"
                :starRight="0.2"
              ></StarCount>
            </div>
            <div class="main1_score">
              5.0
            </div>
          </a>
        </div>
      </template>
    </GamesMore>
    <div class="adsItem" style="display: flex; justify-content: center; align-items: center; width: 100%; overflow: hidden;">
      <div id='div-gpt-ad-1784883107220-0' style='min-width: 300px; min-height: 250px;'></div>
    </div>
    <GamesMore
      :leftIcon="'Most People Play'"
      :leftText="'Most People Play'"
      v-if="popularList.length > 0"
    >
      <template #content>
        <div class="main2">
          <a
            class="main2-item"
            v-for="(item, index) in imgList"
            :key="index"
            :href="`detail.html?id=${item.id}`"
          >
            <img v-lazy="item.gamelogo" alt="" class="tupian" />
            <div class="right">
              <h1 class="name">{{ item.gamename }}</h1>
              <div class="main2_play">
                {{ Math.floor(Math.random() * 11) + 20 }} PLAY
              </div>
            </div>
          </a>
        </div>
      </template>
    </GamesMore>
    <GamesMore
      :leftIcon="'Popular Game'"
      :leftText="'Popular Game'"
      v-if="popularList.length > 0"
    >
      <template #content>
        <div class="main3">
          <a
            class="main3-item"
            v-for="(item, index) in perList"
            :key="index"
            :href="`detail.html?id=${item.id}`"
          >
            <img :src="item.gameBigImage" alt="" class="main3_tupian" />
            <div class="main3_bottom">
              <h1 class="name">{{ item.gamename }}</h1>
              <StarCount
                :imgUrl="star"
                :starwidth="0.27"
                :starRight="0.2"
              ></StarCount>
            </div>
            <div class="main3_score">
              5.0
            </div>
          </a>
        </div>
      </template>
    </GamesMore>
    <GamesMore
      :leftIcon="'Newly Released Game'"
      :leftText="'Newly Released Game'"
      v-if="popularList.length > 0"
    >
      <template #content>
        <div class="main4">
          <a
            class="main4-item"
            v-for="item in cacualList"
            :key="item.id"
            :href="`detail.html?id=${item.id}`"
          >
            <img v-lazy="item.gamelogo" alt="" class="item_pic" />
            <div class="beside">
              <p class="name">{{ item.gamename }}</p>
              <p class="play">{{ Math.floor(Math.random() * 11) + 20 }} PLAY</p>
              <StarCount :imgUrl="star" :starwidth="0.27"></StarCount>
            </div>
            <div class="start">
              <p>PLAY</p>
            </div>
            <div class="main4_score">
              5.0
            </div>
          </a>
        </div>
      </template>
    </GamesMore>
    <GamesMore
      :leftIcon="'Top Games'"
      :leftText="'Top Games'"
      v-if="popularList.length > 0"
    >
      <template #content>
        <div class="main5">
          <a
            v-for="(item, index) in topList.slice(0, 3)"
            :key="item.id"
            :href="`detail.html?id=${item.id}`"
            class="main5-three"
          >
            <img v-lazy="item.gamelogo" alt="" class="main5_tupian" />
            <img
              src="@/assets/images/one.png"
              alt=""
              class="main5_icon"
              v-if="index == 0"
            />
            <img
              src="@/assets/images/two.png"
              alt=""
              class="main5_icon"
              v-if="index == 1"
            />
            <img
              src="@/assets/images/three.png"
              alt=""
              class="main5_icon"
              v-if="index == 2"
            />
          </a>
          <a
            class="main5-item"
            v-for="(item, index) in topList.slice(3)"
            :key="item.id"
            :href="`detail.html?id=${item.id}`"
          >
            <img v-lazy="item.gamelogo" alt="" class="main5_tupian" />
            <div class="main5_score">
              {{ index + 4 }}
            </div>
          </a>
        </div>
      </template>
    </GamesMore>
    <GamesMore
      :leftIcon="'People Likes Games'"
      :leftText="'People Likes Games'"
      v-if="popularList.length > 0"
    >
      <template #content>
        <div class="main6">
          <a
            class="main6-item"
            v-for="(item, index) in newList"
            :key="index"
            :href="`detail.html?id=${item.id}`"
          >
            <img v-lazy="item.gamelogo" alt="" />
            <h1 class="name">{{ item.gamename }}</h1>
            <p class="play">{{ Math.floor(Math.random() * 11) + 20 }} PLAY</p>
            <div class="main6_score">
              5.0
            </div>
          </a>
        </div>
      </template>
    </GamesMore>
    <GamesMore
      :leftIcon="'FEATURED GAMES'"
      :leftText="'FEATURED GAMES'"
      v-if="popularList.length > 0"
    >
      <template #content>
        <div class="main7">
          <a
            class="main7-item"
            v-for="(item, index) in bestList"
            :key="index"
            :href="`detail.html?id=${item.id}`"
          >
            <img :src="item.gameBigImage" alt="" class="main7_tupian" />
            <div class="mask"></div>
            <h1 class="name">{{ item.gamename }}</h1>
          </a>
        </div>
      </template>
    </GamesMore>
    <div class="desc">
      <p class="first">Free H5 Game - Play OCEANWAVE</p>
      <p style="margin-top: 30px">
        OCEANWAVE is a browser game platform that features the best free online
        games. All of our games run in the browser and can be played instantly
        without downloads or installs. You can play on OCEANWAVE on any device,
        including laptops, smartphones, and tablets. This means that whether you
        are at home, at school, or at work, it's easy and quick to start
        playing! Every month lots of people play our games.We publish new Html5
        games every month and currently have more than 100 which you can freely
        play, without any download or installation. Our games are all free and
        unblocked, you won't have to pay a cent to play and have fun with them.
        They are also safe and secure, your device will be happy to surf through
        our website and explore its pages, its battery may be less content
        though ;We feature over 200 games in all genres that you can imagine.
        Our most popular games are: .Io Games、Minecraft Games、Car Games、Gun
        games and many games from Poki Games, Crazy Games Should you have any
        feedback for us, please don't hesitate to reach out. Have fun on Free H5
        Game.com!You will love our games about Poki games,Crazy games and more
        Discover all games! About OCEANWAVE OCEANWAVE was founded in 2024 and
        has been providing free online game since then. Our goal is to provide
        the best possible gaming experience in the browser. You can reach out,
        check our open job positions, or take a look at our game developer
        platform. For more information about OCEANWAVE, you can visit our
        corporate site.
      </p>
    </div>
    <GamesDescribe></GamesDescribe>
  </div>
</template>

<script>
// @ is an alias to /src
import { getgame } from "@/services/api.js";
import TopBar from "@/components/TopBar.vue";
import HeaderBar from "@/components/HeaderBar.vue";
import Swiper from "@/components/Swiper.vue";
import CustomHeader from "@/components/CustomHeader.vue";
import GamesMore from "@/components/GamesMore.vue";
import SlidesPer from "@/components/SlidesPer.vue";
import StarCount from "@/components/StarCount.vue";
import HeaderSwiper from "@/components/HeaderSwiper.vue";
import GamesDescribe from "@/components/GamesDescribe.vue";
import Skeleton from "@/components/Skeleton.vue";
import star from "@/assets/images/star.png";
import data1 from "@/data/1.json";
import data2 from "@/data/2.json";
import data3 from "@/data/3.json";
import data4 from "@/data/4.json";
import data5 from "@/data/5.json";
import data6 from "@/data/6.json";
import data7 from "@/data/7.json";
export default {
  name: "Home",
  components: {
    TopBar,
    Swiper,
    HeaderBar,
    CustomHeader,
    GamesMore,
    SlidesPer,
    StarCount,
    HeaderSwiper,
    GamesDescribe,
    Skeleton,
  },
  data() {
    return {
      star,
      searchKeyword: "",
      imgList: [],
      perList: [],
      bestList: [],
      popularList: [],
      cacualList: [],
      topList: [],
      newList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      // let Data1 = await getgame({
      //   type: "HOT GAMES",
      //   page: 11,
      // });
      // let Data2 = await getgame({
      //   type: "HOT GAMES",
      //   page: 12,
      // });
      // let Data3 = await getgame({
      //   type: "HOT GAMES",
      //   page: 13,
      // });
      // let Data4 = await getgame({
      //   type: "HOT GAMES",
      //   page: 14,
      // });
      // let Data5 = await getgame({
      //   type: "HOT GAMES",
      //   page: 15,
      // });
      // let Data6 = await getgame({
      //   type: "HOT GAMES",
      //   page: 16,
      // });
      // let Data7 = await getgame({
      //   type: "HOT GAMES",
      //   page: 17,
      // });
      this.imgList = data1;
      this.bestList = data2;
      this.perList = data3;
      this.popularList = data4;
      this.cacualList = data5;
      this.topList = data6;
      this.newList = data7;
      // window.addAds();
    },
    //获取轮播图数据
    async toSearch() {
      window.location.href = `search.html?name=${this.searchKeyword}`;
    },
    getBanner1() {
      const script = document.createElement("script");
      script.innerHTML = `
      googletag.cmd.push(function() { googletag.display('div-gpt-ad-1719305447705-0'); });
    `;
      document.getElementById("div-gpt-ad-1719305447705-0").appendChild(script);
    },
    getBanner2() {
      const scripts = document.createElement("script");
      scripts.innerHTML = `
      googletag.cmd.push(function() { googletag.display('div-gpt-ad-1719305466770-0'); });
    `;
      document
        .getElementById("div-gpt-ad-1719305466770-0")
        .appendChild(scripts);
    },
    getBanner3() {
      const scripts = document.createElement("script");
      scripts.innerHTML = `
      googletag.cmd.push(function() { googletag.display(staticSlot); });
    `;
      document
        .getElementById("div-gpt-ad-1719305508999-0")
        .appendChild(scripts);
    },
    getBanner4() {
      const scripts = document.createElement("script");
      scripts.innerHTML = `
      googletag.cmd.push(function() { googletag.display(staticSlot); });
    `;
      document
        .getElementById("div-gpt-ad-1719305534361-0")
        .appendChild(scripts);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";
ins.adsbygoogle[data-ad-status="unfilled"] {
  display: none !important;
}
.home {
  width: 1080px;
  margin: 0 auto;
  overflow: hidden;
  background-color: #000000;
  .form-search {
    width: 1000px;
    height: 110px;
    background: #272b35;
    margin: 0 auto 100px;
    position: relative;
    .ipt-search {
      width: 100%;
      height: 110px;
      background: #272b35;
      outline: none;
      border-radius: 30px;
      text-indent: 94px;
      font-size: 50px;
      font-weight: 900;
      border: 0;
      color: #ffffff;
    }
    .btn-searchs {
      right: 40px;
      top: 25px;
      position: absolute;
      background: url("../../../assets/images/sousuo.png") center center
        no-repeat;
      background-size: 100%;
      width: 59px;
      height: 58px;
    }
  }
  .main1 {
    width: 1000px;
    margin: 38px auto;
    display: flex;
    flex-wrap: wrap;
    .main1-item:nth-child(3n-1) {
      margin: 0px 50px;
    }
    .main1-item {
      width: 300px;
      height: 432px;
      background: rgba(255, 255, 255, 0.1);
      margin-bottom: 40px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      padding: 41px 0px;
      color: #ffffff;
      position: relative;
      img {
        width: 300px;
        height: 300px;
      }
      .name {
        text-align: center;
        font-size: 40px;
        font-weight: bold;
        width: 90%;
        line-height: 60px;
        @include textoverflow(1);
      }
      .main1_score {
        width: 80px;
        height: 80px;
        background: #ff6464;
        position: absolute;
        right: 0;
        top: 0;
        text-align: center;
        line-height: 80px;
        font-size: 40px;
        font-weight: 900;
        color: #ffffff;
      }
    }
  }
  .main2 {
    width: 1000px;
    margin: 38px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .main2-item {
      width: 480px;
      height: 200px;
      background: rgba(255, 255, 255, 0.1);
      display: flex;
      margin-bottom: 40px;
      .tupian {
        width: 200px;
        height: 200px;
      }
      .right {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        margin-left: 20px;

        .name {
          color: #ffffff;
        }
        .main2_play {
          color: #ff6464;
          margin-left: 70px;
        }
      }
    }
  }
  .main3 {
    width: 1000px;
    margin: 38px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .main3-item {
      width: 480px;
      height: 424px;
      background: #272b35;
      margin-bottom: 40px;
      position: relative;
      .main3_tupian {
        width: 480px;
        height: 287.63px;
      }
      .main3_bottom {
        margin: 17px 0px 0px 20px;
      }
      .name {
        font-size: 35px;
        font-weight: bold;
        color: #ffffff;
        margin-bottom: 30px;
        width: 90%;
        @include textoverflow(1);
      }
      .main3_score {
        width: 80px;
        height: 80px;
        background: #ff6464;
        position: absolute;
        right: 0;
        top: 0;
        text-align: center;
        line-height: 80px;
        font-size: 40px;
        font-weight: 900;
        color: #ffffff;
      }
    }
  }
  .main4 {
    width: 1000px;
    margin: 38px auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .main4-item {
      width: 100%;
      height: 200px;
      background: #272b35;
      margin-bottom: 50px;
      display: flex;
      align-items: center;
      color: #ffffff;
      font-weight: bold;
      position: relative;
      .item_pic {
        width: 200px;
        height: 200px;
      }
      .beside {
        height: 190px;
        margin: 0px 200px 0px 50px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .play {
          font-size: 30px;
          font-weight: normal;
          color: #ff6464;
          margin: 0px 0px 10px;
        }
        .name {
          font-size: 45px;
          width: 292px;
          height: 60px;
          line-height: 60px;
          @include textoverflow(1);
        }
      }
      .start {
        width: 201px;
        height: 84px;
        background: #ff6464;
        text-align: center;
        p {
          line-height: 90px;
          font-size: 45px;
        }
      }
      .main4_score {
        width: 50px;
        height: 50px;
        background: #ff6464;
        position: absolute;
        left: 150px;
        top: 0;
        text-align: center;
        line-height: 50px;
        font-size: 25px;
        font-weight: 900;
        color: #ffffff;
      }
    }
  }
  .main5 {
    width: 1000px;
    margin: 38px auto;
    display: flex;
    flex-wrap: wrap;

    .main5_tupian {
      width: 100%;
      height: 100%;
    }
    .main5-three:nth-child(2n) {
      margin: 0px 40px 40px 39px;
    }
    .main5-three {
      display: block;
      width: 307px;
      height: 307px;
      position: relative;
      margin: 0px 0px 40px 0px;
      .main5_icon {
        position: absolute;
        right: 0;
        top: 0;
        width: 129px;
        height: 60px;
      }
    }

    .main5-item:nth-child(4n + 3) {
      margin: 0px 0px 40px;
    }
    .main5-item {
      display: block;
      width: 220px;
      height: 220px;
      position: relative;
      margin: 0px 40px 40px 0px;
      .main5_score {
        width: 50px;
        height: 50px;
        background: #ff6464;
        position: absolute;
        right: 0;
        top: 0;
        text-align: center;
        line-height: 50px;
        font-size: 25px;
        font-weight: 900;
        color: #ffffff;
      }
    }
  }
  .main6 {
    width: 1000px;
    margin: 38px auto;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .main6-item:nth-child(3n-1) {
      margin: 0px 50px 50px;
    }
    .main6-item {
      width: 300px;
      height: 335px;
      background: rgba(255, 255, 255, 0.1);
      margin-bottom: 50px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      color: #ffffff;
      position: relative;
      padding: 0px 0px 40px;
      img {
        width: 300px;
        height: 202px;
      }
      .name {
        text-align: center;
        font-size: 40px;
        font-weight: bold;
        width: 90%;
        line-height: 60px;
        height: 60px;
        @include textoverflow(1);
      }
      .play {
        font-size: 30px;
        font-weight: normal;
        color: #ff6464;
        text-align: left;
        width: 80%;
      }
      .main6_score {
        width: 50px;
        height: 50px;
        background: #ff6464;
        position: absolute;
        right: 0;
        top: 0;
        text-align: center;
        line-height: 50px;
        font-size: 25px;
        font-weight: 900;
        color: #ffffff;
      }
    }
  }
  .main7 {
    width: 1001px;
    margin: 38px auto;
    display: flex;
    flex-wrap: wrap;
    .main7-item:nth-child(3n-1) {
      margin: 0px 40px 40px;
    }
    .main7-item {
      width: 307px;
      height: 307px;
      margin-bottom: 40px;
      position: relative;
      .main7_tupian {
        width: 100%;
        height: 100%;
      }
      .mask {
        width: 100%;
        height: 80px;
        background: rgba(0, 0, 0, 0.75);
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .name {
        font-size: 40px;
        font-weight: 500;
        color: #ffffff;
        position: absolute;
        left: 20px;
        bottom: 15px;
        width: 90%;
        line-height: 50px;
        @include textoverflow(1);
      }
    }
  }

  .desc {
    width: 860px;
    background: #272b35;
    margin: 80px auto 0px;
    padding: 50px 70px;
    .first {
      width: 100%;
      text-align: center;
      font-weight: 900;
      font-size: 50px;
    }
    p {
      font-weight: 500;
      font-size: 30px;
      line-height: normal;
      color: #ffffff;
    }
  }
}
</style>
